import React, { PureComponent, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import openLoginModal from 'shared-utils/src/login/openLoginModal';
import sleep from 'shared-utils/src/sleep';
import { getCollectionNode } from 'shared-utils/src/myCasaCollections';
import { readPublisherCounters } from 'shared-utils/src/hooks/useCollectionCounts';
import { MY_COLLECTIONS_TYPES, MY_COLLECTIONS_IDS } from 'shared-constants/src/mycasa26/collection_configurations';

import HeaderMenu from 'shared-components/components/HeaderMenu';
import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import { setAttribution, TRACKING_DEBUG } from 'shared-utils/src/helpersMyCasa/mycasaTracking';
import Footer from 'shared-components/components/Footer/lazy';
import SimpleFooter from 'shared-components/components/SimpleFooter';

import {
  createLoginModal,
  createConsentRequestModal,
  createConsentTCModal,
} from '@components/modals/factories';
import Modal from '@async-components/Modal';

import MyCasaFakeEngage from 'shared-components/components/MyCasaFakeEngage';
import MyCasaFakeEngageLoader from 'client/loaders/components/MyCasaFakeEngage';

import ConsentModal from './ConsentModal';
import SaveAddressDialog from '../searchMap/components/layout/SaveAddressDialog';
import HandleAddressesModal from '../searchMap/components/layout/HandleAddressesModal';

const propTypes = {
  device: PropTypes.string,
  store: PropTypes.instanceOf(Object),
  config: PropTypes.instanceOf(Object),
  children: PropTypes.instanceOf(Object),
  modal: PropTypes.bool,
  user: PropTypes.instanceOf(Object),
  userLogIn: PropTypes.func,
  userLogOut: PropTypes.func,
  updateGlobalState: PropTypes.func,
  globalReducer: PropTypes.func,
  globalSelector: PropTypes.func,
  pageData: PropTypes.object,
  pageType: PropTypes.string,
  globalState: PropTypes.object,
  viewportHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mobileOs: PropTypes.string,
  browserBackButton: PropTypes.func,
  appReducer: PropTypes.func,
  orientation: PropTypes.string,
  iosLth12: PropTypes.bool,
  viewportWidth: PropTypes.number,
  showConsentModal: PropTypes.bool,
  navigationCycle: PropTypes.number,
};

const defaultProps = {
  device: '',
  store: {},
  config: {},
  children: [],
  modal: false,
  pageData: {},
  pageType: '',
  user: {},
  globalState: {},
  userLogIn: () => { },
  userLogOut: () => { },
  updateGlobalState: () => { },
  globalReducer: () => { },
  globalSelector: () => { },
  viewportHeight: null,
  mobileOs: null,
  browserBackButton: null,
  appReducer: () => { },
  orientation: '',
  iosLth12: false,
  viewportWidth: 0,
  showConsentModal: false,
  navigationCycle: 0,
};

export const CtxContainer = React.createContext();
export const useCtxGlobal = () => useContext(CtxContainer);

// const Debug = () => {
//   const [show, setShow] = useState(null);
//   useEffect(() => { if (window && window.localStorage) {
//     if (window.localStorage.getItem('signinData')) {
//       setShow(window.localStorage.getItem('signinData').replace(/,/g, ', '));
//     }
//   } }, []);

//   return show;
// };

class Container extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modal: {},
      wh: null,
      user: props.user || {},
      handleAddressesModalData: null,
      saveAddressDialogData: null,
    };
    this.refModal = React.createRef();
    this.contextValue = {};
  }

  componentDidMount() {
    window.addEventListener('popstate', this.onBackButtonEvent);
    window.addEventListener('myCasaCollectionsChange', this.onCollectionsChange);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackButtonEvent);
    window.removeEventListener('myCasaCollectionsChange', this.onCollectionsChange);
  }

  onCollectionsChange = () => {
    // Force re-render so collectionCounts in render() re-reads from localStorage
    this.forceUpdate();
  };

  onBackButtonEvent = (e) => {
    const { modal } = this.state;
    const { browserBackButton, pageData: { filtersDialog } } = this.props;

    if (filtersDialog) {
      e.preventDefault();
      return;
    }

    if (Object.keys(modal).length) {
      e.preventDefault();
      this.updateModal({ forceClose: true });
      return;
    }

    if (browserBackButton) {
      e.preventDefault();
      browserBackButton();
      return;
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const state = {};
    const {
      user = {},
      device,
      mobileOs,
    } = nextProps;
    if (
      (
        user.username
        && (user.username !== prevState.user.username)
      ) || (
        user.formData
        && prevState.user.formData
        && user.formData.consent !== prevState.user.formData.consent
      )
    ) {
      state.user = user;
    }

    if (device === 'smartphone' && mobileOs === 'ios' && prevState.wh === null) {
      state.wh = window.innerHeight;
    }

    return state;
  }

  getCurrentUrl = () => {
    const { store: { location }, config: { siteUrl } } = this.props;
    // proviamo a prenderlo dallo store redux
    let currentUrl = location ? `${location.pathname}${location.search}` : null;
    // se non esiste nello store redux proviamo a prenderlo da window
    if (!currentUrl && typeof window !== 'undefined') {
      currentUrl = `${window.location.pathname}${window.location.search}`;
    }
    // se siamo rimasti a secco, ritorniamo la hp
    if (!currentUrl) {
      currentUrl = siteUrl;
    }
    return currentUrl;
  }

  renderModal = () => {
    const { modal } = this.state;
    return (
      <Modal
        title={modal.title || null}
        className={modal.className || null}
        content={modal.content || null}
        container={modal.container ? data => modal.container(data) : null}
        open={!!Object.keys(modal).length}
        actions={modal.actions || null}
        inlineActions={modal.inlineActions || null}
        footer={modal.footer || null}
        forceClose={modal.forceClose || false}
        onClose={this.closeModal}
        width={modal.width || null}
        height={modal.height || null}
        minHeight={modal.minHeight || null}
        compactHeader={modal.compactHeader || false}
        afterClose={modal.afterClose || null}
        header={modal.header || true}
        headerNoShadow={modal.headerNoShadow || false}
        headerNoBorder={modal.headerNoBorder || false}
        fullContent={modal.fullContent || false}
        fullScreen={modal.fullScreen || false}
        version={modal.version || null}
        borderRadius={modal.borderRadius || null}
        lockscreenCustomCls={modal.lockscreenCustomCls || null}
        trackOnClose={modal.trackOnClose || null}
        trackOnBack={modal.trackOnBack || null}
        trackPVOnClose={modal.trackPVOnClose || null}
        disableOvrl={modal.disableOvrl || null}
        disableHistoryBackOnClose={modal.disableHistoryBackOnClose || false}
        isMultiPanel={modal.isMultiPanel || false}
      />
    );
  }

  openModal = async (props, opts = {}) => {
    if (!opts.doNotPushHistory) {
      sleep(300).then(() => window.history.pushState({}, null, null));
    }
    opts.close && await this.closeModal();
    this.setState({
      modal: {
        ...props,
        v2: 1,
        close: this.closeModal,
      },
    });
    document.querySelector('#app').setAttribute('aria-hidden', 'true');
  }

  updateModal = async (props) => {
    const { modal } = this.state;
    this.setState({
      modal: modal ? {
        ...modal,
        ...props,
      } : modal,
    });
  }

  makeModalClose = () => {
    const { modal } = this.state;
    this.setState({
      modal: {
        ...modal,
        forceClose: true,
      },
    });
  }

  closeModal = async func => sleep(201).then(() => {
    document.querySelector('#app').removeAttribute('aria-hidden');
    if (func && typeof func === 'function') {
      return func();
    }
    return this.setState({ modal: {} });
  });


  getUser = () => {
    const { user } = this.props;
    return user;
  }

  getUserLoginPayload = ({
    postLoginAction = null,
    from = null,
    position = null,
    opts = null,
  } = {}) => {
    const {
      device,
      mobileOs,
      viewportHeight,
      config: {
        reCAPTCHA,
        cookiesConfig,
        siteUrl,
        credentials: {
          appleClientId,
        },
        api: {
          account,
          authBasePrefix,
        },
      },
      userLogIn,
    } = this.props;

    const {
      knownUser = null,
      mustRegister = null,
      postOTPRequestAction = null,
      onCloseWithoutLogin = null,
    } = opts || {};

    return {
      device,
      mobileOs,
      viewportHeight,
      portalDomain: siteUrl,
      accountDomain: account,
      authBasePrefix,
      logIn: userLogIn,
      onLogInComplete: this.closeModal,
      postLoginAction,
      cookiesConfig,
      reCAPTCHA,
      appleClientId,
      from,
      position,
      createConsentRequestModal,
      createConsentTCModal,
      knownUser,
      mustRegister,
      postOTPRequestAction,
      onCloseWithoutLogin,
    };
  }

  userLogin = (clb, from = 'headerLoginButton', position, opts = {}) => {
    const { pageData: { showSynchingDialog } } = this.props;

    const closeModalAction = payload => this.closeModal(payload.close);

    let postLoginAction = null;
    if (typeof clb === 'function') {
      postLoginAction = (props) => {
        if (showSynchingDialog) showSynchingDialog(props);
        clb(props);
      };
    } else if (showSynchingDialog) {
      postLoginAction = showSynchingDialog;
    }

    const loginModalData = this.getUserLoginPayload({ postLoginAction, from, position, opts });

    openLoginModal({
      openModalAction: this.openModal,
      closeModalAction,
      createLoginModal,
      loginModalData,
    });
  };

  showHandleAddressesModal = (data = null) => this.setState({ handleAddressesModalData: data });

  showSaveAddressDialog = (address = null) => this.setState({ saveAddressDialogData: address });

  render() {
    const {
      config,
      pageData,
      pageType,
      appReducer,
      globalReducer,
      globalSelector,
      updateGlobalState,
      globalState,
      device,
      mobileOs,
      orientation,
      iosLth12,
      store: {
        home,
        search,
        searchMap,
        agentPro,
        account,
        subscription,
        qrcodeHandler,
        cercacasa,
        deactivation,
        deactivationAlerts,
        manageConsents,
        removeMailAndConsents,
        agencyHome,
        cercaintornoate,
        mycasafake,
      },
      children,
      user,
      userLogIn,
      userLogOut,
      viewportWidth,
      viewportHeight,
      modal: propsModal,
      showConsentModal,
      navigationCycle,
    } = this.props;

    const {
      // scrollCoords,
      modal: stateModal,
      handleAddressesModalData,
      saveAddressDialogData,
    } = this.state;

    const isHome = Object.keys(home).length && !('found' in home);
    const noHeaderFooter = Object.keys(subscription || {})?.length ||
      Object.keys(account || {})?.length ||
      Object.keys(deactivation || {})?.length ||
      Object.keys(qrcodeHandler || {})?.length ||
      Object.keys(cercacasa || {})?.length ||
      Object.keys(deactivationAlerts || {})?.length ||
      Object.keys(manageConsents || {})?.length ||
      Object.keys(removeMailAndConsents || {})?.length ||
      Object.keys(cercaintornoate || {})?.length;

    const isAuctionHome = isHome && home?.filters?.isAuction === true;
    const isSrp = Object.keys(search).length;
    const isSrpMap = Object.keys(searchMap).length;
    const isAgentPro = Object.keys(agentPro).length;
    const isAgencyHome = Object.keys(agencyHome).length;
    const isCercacasa = Object.keys(cercacasa).length;
    const isDeactivationAlerts = Object.keys(deactivationAlerts || {}).length;
    const isManageConsents = Object.keys(manageConsents || {}).length;
    const isRemoveMailAndConsents = Object.keys(removeMailAndConsents || {}).length;
    const isCercaIntornoATe = Object.keys(cercaintornoate || {}).length;
    const isMyCasaFake = Object.keys(mycasafake || {}).length;


    let model = null;
    if (isHome) {
      model = home;
    } else if (isSrp) {
      model = search;
    } else if (isSrpMap) {
      model = searchMap;
    } else if (isAgentPro) {
      model = agentPro;
    } else if (isAgencyHome) {
      model = agencyHome;
    } else if (isCercacasa) {
      model = cercacasa;
    } else if (isDeactivationAlerts) {
      model = deactivationAlerts;
    } else if (isManageConsents) {
      model = manageConsents;
    } else if (isRemoveMailAndConsents) {
      model = removeMailAndConsents;
    } else if (isCercaIntornoATe) {
      model = cercaintornoate;
    } else if (isMyCasaFake) {
      model = mycasafake;
    }

    const modal = propsModal || stateModal ? this.renderModal() : null;
    let containerCssClassName = 'casait';
    if (device !== 'desktop') {
      containerCssClassName += ' touchscreen';
      if (pageData.openSelect) {
        containerCssClassName += ' hdrnosel';
      }
    }
    if (mobileOs === 'android') {
      containerCssClassName += ' android';
    }
    if (isMyCasaFake) {
      containerCssClassName += ' ls-mycasa';
    }

    const userUrls = {};
    userUrls.accounthost = config.api.account;
    userUrls.authBasePrefix = config.api.authBasePrefix;
    userUrls.userhost = config.apiEndPoints.mycasaUser;
    userUrls.links = config.mycasaLinks;
    const isAuth = user.isAuthenticated;
    const isNotVerified = user.isNotVerified;

    let collectionCounts = {};
    if (isAuth) {
      const adsSaved = getCollectionNode(MY_COLLECTIONS_TYPES.ADS, MY_COLLECTIONS_IDS.SAVED);
      const adsNote = getCollectionNode(MY_COLLECTIONS_TYPES.ADS, MY_COLLECTIONS_IDS.NOTE);
      const adsRecent = getCollectionNode(MY_COLLECTIONS_TYPES.ADS, MY_COLLECTIONS_IDS.RECENT);
      const searchesSaved = getCollectionNode(MY_COLLECTIONS_TYPES.SEARCHES, MY_COLLECTIONS_IDS.SAVED);
      const searchesRecent = getCollectionNode(MY_COLLECTIONS_TYPES.SEARCHES, MY_COLLECTIONS_IDS.RECENT);
      const contactsAd = getCollectionNode(MY_COLLECTIONS_TYPES.CONTACTS, MY_COLLECTIONS_IDS.AD);

      const publisherCounts = readPublisherCounters();
      collectionCounts = {
        favoritesCount: adsSaved?.count || 0,
        contactedCount: contactsAd?.count || 0,
        notesCount: adsNote?.count || 0,
        recentCount: adsRecent?.count || 0,
        savedSearchesCount: searchesSaved?.count || 0,
        recentSearchesCount: searchesRecent?.count || 0,
        publishedAds: publisherCounts?.publishedAds || 0,
        totalAds: publisherCounts?.totalAds || 0,
      };
    }

    const isMobile = device ? device.indexOf('smartphone') >= 0 : false;

    const contextValue = {
      openModal: this.openModal,
      updateModal: this.updateModal,
      closeModal: this.closeModal,
      isMobile,
      isDesktop: device ? device.indexOf('desktop') >= 0 : false,
      isSmallMobile: isMobile && (viewportWidth || 0) < 360,
      iosLth12,
      viewportHeight,
      updateGlobalState,
      globalState,
      appReducer,
      globalReducer,
      globalSelector,
      pageType,
      model,
      user,
      userConf: {
        userLogIn,
        userUrls,
      },
      isAuth,
      siteUrl: config.siteUrl,
      mobileOs,
      orientation,
      constantsCopy: config.constantsCopy,
      logIn: this.userLogin,
      getUserLoginPayload: this.getUserLoginPayload,
      getUser: this.getUser,
      handleAddressesModalData,
      showHandleAddressesModal: this.showHandleAddressesModal,
      saveAddressDialogData,
      showSaveAddressDialog: this.showSaveAddressDialog,
      navigationCycle,
      ...pageData,
    };

    if (isSrpMap) {
      return (
        <CtxContainer.Provider value={contextValue}>
          <div className={containerCssClassName}>
            {children}
            {modal}
            <HandleAddressesModal
              isOpen={handleAddressesModalData}
              close={this.showHandleAddressesModal}
            />
            <SaveAddressDialog
              isOpen={saveAddressDialogData}
              close={this.showSaveAddressDialog}
            />
            <ConsentModal
              showConsentModal={showConsentModal}
              isMobile={device === 'smartphone'}
              user={user}
              hasToShowTCModalConsent={user?.hasToShowTCModalConsent}
              accountDomain={userUrls.accounthost}
              openModal={this.openModal}
            />
          </div>
        </CtxContainer.Provider>
      );
    }

    const footerComp = (
      <Footer
        is404={pageType === 'notfound'}
        domain={config.siteUrl}
        fromPortal
      />
    );

    const accountMenuProps = {
      onLogout: userLogOut,
      userName: user?.displayname || user?.displayName,
      userEmail: user?.username || user?.formData?.email,
      ...collectionCounts,
      onAnnunciSectionClick: (e) => {
        if (e.target.closest('a')) {
          TRACKING_DEBUG && console.log('[HeaderTracking] setAttribution menuTab (annunci section click)');
          setAttribution('menuTab');
        }
      },
      onRicercheSectionClick: (e) => {
        if (e.target.closest('a')) {
          TRACKING_DEBUG && console.log('[HeaderTracking] setAttribution userMenu (ricerche section click)');
          setAttribution('userMenu');
        }
      },
    };

    const headerComp = !isHome
      ? (
        <div className="csa_header-container">
          <HeaderMenu
            isLogged={isAuth}
            isNotVerified={isNotVerified}
            userName={user.displayname || user.displayName}
            onClickLogin={this.userLogin}
            onOpenMenu={() => { TRACKING_DEBUG && console.log('[HeaderTracking] openUserMenu', { category: 'MyCasa', action: 'openUserMenu', event_origin: 'headerLoginButton' }); trackGTMEvents({ category: 'MyCasa', action: 'openUserMenu', event_origin: 'headerLoginButton' }); }}
            onCloseMenu={() => { TRACKING_DEBUG && console.log('[HeaderTracking] closeUserMenu', { category: 'MyCasa', action: 'closeUserMenu', event_origin: 'headerLoginButton' }); trackGTMEvents({ category: 'MyCasa', action: 'closeUserMenu', event_origin: 'headerLoginButton' }); }}
            verifyHref={userUrls.links?.verifica || '/my/annunci-ricerche-temporanei/'}
            publishHref={userUrls.links?.pubblica?.annunci || '/pubblica/annunci'}
            authBasePrefix={userUrls.authBasePrefix}
            accountMenu={accountMenuProps}
          />
        </div>
      ) : (
        <HeaderMenu
          isLogged={isAuth}
          isNotVerified={isNotVerified}
          userName={user.displayname || user.displayName}
          onClickLogin={this.userLogin}
          onOpenMenu={() => { TRACKING_DEBUG && console.log('[HeaderTracking] openUserMenu', { category: 'MyCasa', action: 'openUserMenu', event_origin: 'headerLoginButton' }); trackGTMEvents({ category: 'MyCasa', action: 'openUserMenu', event_origin: 'headerLoginButton' }); }}
          onCloseMenu={() => { TRACKING_DEBUG && console.log('[HeaderTracking] closeUserMenu', { category: 'MyCasa', action: 'closeUserMenu', event_origin: 'headerLoginButton' }); trackGTMEvents({ category: 'MyCasa', action: 'closeUserMenu', event_origin: 'headerLoginButton' }); }}
          isTransparent={!isAuctionHome}
          inlineNav={!isAuctionHome}
          verifyHref={userUrls.links?.verifica || '/my/annunci-ricerche-temporanei/'}
          publishHref={userUrls.links?.pubblica?.annunci || '/pubblica/annunci'}
          authBasePrefix={userUrls.authBasePrefix}
          accountMenu={accountMenuProps}
        />
      );

    const header = noHeaderFooter ? null : headerComp;
    const footer = noHeaderFooter ? null : footerComp;

    if (isMyCasaFake) {
      return (
        <CtxContainer.Provider value={contextValue}>
          <div className={containerCssClassName}>
            {header}
            {children}
            {modal}
            <SimpleFooter />
            <ConsentModal
              showConsentModal={showConsentModal}
              isMobile={device === 'smartphone'}
              user={user}
              hasToShowTCModalConsent={user?.hasToShowTCModalConsent}
              accountDomain={userUrls.accounthost}
              openModal={this.openModal}
            />
            <HandleAddressesModal
              isOpen={handleAddressesModalData}
              close={this.showHandleAddressesModal}
            />
            <SaveAddressDialog
              isOpen={saveAddressDialogData}
              close={this.showSaveAddressDialog}
            />
          </div>
        </CtxContainer.Provider>
      );
    }

    return (
      <CtxContainer.Provider value={contextValue}>
        <div className={containerCssClassName}>
          {pageType === 'srp' ? (
            <MyCasaFakeEngage
              user={user}
              isMobile={device === 'smartphone'}
              logIn={this.userLogin}
              asyncComponent={MyCasaFakeEngageLoader}
            />
          ) : null}
          {header}
          {/* <Debug /> */}
          {children}
          {modal}
          {footer}
          <ConsentModal
            showConsentModal={showConsentModal}
            isMobile={device === 'smartphone'}
            user={user}
            hasToShowTCModalConsent={user?.hasToShowTCModalConsent}
            accountDomain={userUrls.accounthost}
            openModal={this.openModal}
          />
          <HandleAddressesModal
            isOpen={handleAddressesModalData}
            close={this.showHandleAddressesModal}
          />
          <SaveAddressDialog
            isOpen={saveAddressDialogData}
            close={this.showSaveAddressDialog}
          />
        </div>
      </CtxContainer.Provider>
    );
  }
}
Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
export default Container;
